<template>
  <div :class="containerClass">
    <div
      :class="{
        [`${baseClass}__head ${classHead}`]: true,
        'no-hover': !openOnHeadClick,
      }"
      ref="head"
    >
      <div
        :class="`${baseClass}__head__inner ${classHeadInner}`"
        ref="headInner"
      >
        <slot
          name="head"
          :state="state"
          :toggle="toggle"
          :open="open"
          :close="close"
          :refresh="refresh"
        ></slot>
      </div>

      <div
        v-if="useDefaultToggleButton"
        :class="`${baseClass}__buttons ${classButtons}`"
      >
        <button
          @click="toggle"
          ref="buttonToggle"
          :class="`${baseClass}__btn-toggle`"
        ></button>
      </div>
    </div>
    <div
      v-if="disableCollapse"
      ref="body"
      :class="`${baseClass}__body ${classBody}`"
    >
      <div
        ref="bodyInner"
        :class="`${baseClass}__body__inner ${classBodyInner}`"
      >
        <slot
          name="body"
          :state="state"
          :toggle="toggle"
          :open="open"
          :close="close"
          :refresh="refresh"
        ></slot>
      </div>
    </div>
  </div>
</template>

<script>
import anime from "animejs";

export default {
  props: {
    baseClass: {
      type: String,
      default: "collapsible",
    },
    classHead: {
      type: String,
      default: "",
    },
    classHeadInner: {
      type: String,
      default: "",
    },
    disableCollapse: {
      type: Boolean,
      default: true,
    },
    classBody: {
      type: String,
      default: "",
    },
    classBodyInner: {
      type: String,
      default: "",
    },
    classButtons: {
      type: String,
      default: "",
    },
    useDefaultToggleButton: {
      type: Boolean,
      default: true,
    },
    openOnHeadClick: {
      type: Boolean,
      default: true,
    },
    closeOnHeadClick: {
      type: Boolean,
      default: false,
    },
    animationOptions: {
      type: Object,
      default: () => {
        return {
          easing: "linear",
          duration: 200,
        };
      },
    },
  },
  data() {
    return {
      state: "closed",
    };
  },
  computed: {
    containerClass() {
      let cls = {};

      cls[this.baseClass] = true;
      cls[this.baseClass + "--" + this.state] = true;
      cls[this.baseClass + "--open"] =
        this.state == "opening" || this.state == "opened";
      cls[this.baseClass + "--close"] =
        this.state == "closing" || this.state == "closed";

      return cls;
    },
  },
  mounted() {
    this.$refs.headInner.addEventListener("click", (ev) => {
      let toggle =
        (this.state == "closed" && this.openOnHeadClick) ||
        (this.state == "opened" && this.closeOnHeadClick);
      let target = ev.target;

      while (target != this.$refs.headInner) {
        if (toggle && (target.tagName == "BUTTON" || target.tagName == "A")) {
          toggle = false;
          break;
        }
        target = target.parentElement;
      }

      if (toggle) {
        this.toggle();
      }
    });
  },
  methods: {
    open() {
      this.state = "opening";

      anime(
        Object.assign(
          {
            targets: this.$refs.body,
            height: this.$refs.bodyInner.scrollHeight + "px",
            complete: () => {
              this.state = "opened";
              this.$emit("sizechange");
            },
          },
          this.animationOptions
        )
      );
    },
    close() {
      this.state = "closing";

      anime(
        Object.assign(
          {
            targets: this.$refs.body,
            height: "0px",
            complete: () => {
              this.state = "closed";
              this.$emit("sizechange");
            },
          },
          this.animationOptions
        )
      );
    },
    toggle() {
      if (this.state == "opened") {
        this.close();
      } else if (this.state == "closed") {
        this.open();
      }
    },
    refresh() {
      if (
        this.state == "opened" &&
        this.$refs.body.clientHeight != this.$refs.bodyInner.scrollHeight
      ) {
        this.open();
      }
    },
  },
  updated() {
    this.refresh();
  },
};
</script>